export const initialPermissionState = {
  permissions: [],
  permission: null,
  status: 'idle',
  error: null, // ✅ Changed to null instead of an object
};
